 <p-multiSelect #myMultiSelect [options]="options" [(ngModel)]="value" optionLabel="name" optionValue="value"
    [filter]="true" filterBy="name" [autoOptionFocus]="false" (onChange)="onValueChange($event)"
    optionDisabled="inactive" appendTo="body">
</p-multiSelect> 